module.exports = __webpack_public_path__ + "img/hp_font2.30e757a9.png";